import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { memberMobx, payPlanMobx, thirdPartyMobx } from '@mobxStore'
import { Icon } from '@cps'
import { GiftCardAmountModal } from '../../../modal'
import './index.scss'

interface IProps {
}

const GiftCardPay: FC<IProps> = ({ }) => {
  const totalAmountOffCoupon = payPlanMobx.totalAmount - thirdPartyMobx.couponResult.offPrice
  // 查找支付方式
  const findPay = (cardNo) => {
    const payNum = payPlanMobx.giftCardMethodList.find(value => value.giftCard.cardNo === cardNo)?.amount || 0
    return payNum
  }

  // 展示的礼品卡
  const selectedGiftCardList = payPlanMobx.cacheGiftCardShowList?.filter(card => findPay(card.cardNo) > 0)
  const giftCardList = payPlanMobx.showAllGiftCardList ? payPlanMobx.cacheGiftCardShowList : payPlanMobx.cacheGiftCardShowList?.length ? selectedGiftCardList?.length ? selectedGiftCardList : [payPlanMobx.cacheGiftCardShowList[0]] : []

  // 是否有余额为O礼品卡
  const hasBalanceZeroGiftCard = memberMobx.giftCardListForPay?.length !== payPlanMobx.cacheGiftCardShowList?.length

  // 选择
  const onSelect = async (card: IMemberGiftCardInfo) => {
    if (!totalAmountOffCoupon) return
    const amount = await modalLayer<{ card: IMemberGiftCardInfo; fristNum: number }, number>(GiftCardAmountModal, { card, fristNum: totalAmountOffCoupon }, 'giftCardAmountModal')
    payPlanMobx.setGiftCardPayAmount(card, amount)
  }

  // 更改选择
  const changeSelect = (card, e?: any) => {
    if (findPay(card.cardNo) > 0) {
      e.stopPropagation()
      payPlanMobx.setGiftCardPayAmount(card, 0)
    }
  }

  return (
    <div className='gift-card-pay'>
      {
        giftCardList?.map((x, index) => {
          return (
            <div
              key={x.giftcardId + '_' + x.memberCardId}
              className='gift-card'
              data-cypid={`giftCardPay_gcardId_${x?.giftcardId}_mcardId${x?.memberCardId}`}
              onClick={() => onSelect(x)}
            >
              <div className='card-icon'>
                {index === 0 ? <i className='iconfont icon-huiyuanka' /> : ''}
              </div>
              <div className='card-info-member'>
                <div className='balance'>
                  <div className='name'>
                    {
                      i18n.t('pay.giftCardDisplay', {
                        name: x.giftcard.giftcardName || i18n.t('pay.giftCard'),
                        cardNo: format.shortCardNumber(x.cardNo)
                      })
                    }
                  </div>
                  <div className='balance-price'>
                    {i18n.t('pay.cardBalanceN', { n: format.toPrice(x.balance) })}
                  </div>
                </div>
                <div className='amount-info'>
                  {
                    findPay(x.cardNo) && findPay(x.cardNo) > 0 ? (
                      <div>
                        {format.toPrice(findPay(x.cardNo))}
                      </div>
                    ) : ''
                  }
                </div>
              </div>
              <div className='amount-select' data-cypid={`giftCardPaySelect_gcardId_${x?.giftcardId}_mcardId${x?.memberCardId}`} onClick={(e) => { (e) => changeSelect(x, e) }}>
                <i className={classNames('iconfont', (findPay(x.cardNo) > 0) ? 'icon-checked' : 'no-select')} />
              </div>
            </div>
          )
        })
      }
      {payPlanMobx.cacheGiftCardShowList?.length > 1 && (
        <div className='gift-card-tip'>
          {
            hasBalanceZeroGiftCard ? (
              <span>{i18n.t('pay.giftCardTip')}</span>
            ) : <span></span>
          }
          {
            !payPlanMobx.showAllGiftCardList && (
              <span data-cypid='giftCardPayShowAll' onClick={() => payPlanMobx.setShowAllGiftCardList(true)}>
                {i18n.t('pay.showMoreGiftCard')}
                <Icon name='daohangzhankai' />
              </span>
            )
          }
        </div>
      )}
    </div>
  )
}

export default observer(GiftCardPay)
